/* ==========================================================================
   Design System
   Variables
   ========================================================================== */
/* ==========================================================================
   Design System
   Breakpoint variables.

   NOTE: If any of the values in this file are adjusted,
         they need to be adjusted in vars-breakpoints.js as well.
   ========================================================================== */
/* ==========================================================================
   Design System
   Grid mixins
   ========================================================================== */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* ==========================================================================
   Design System
   Media queries
   ========================================================================== */
/* ==========================================================================
   Design System
   Base styles
   ========================================================================== */
.a-label {
  display: inline-block;
}
.a-label__helper {
  color: var(--gray-dark);
  font-size: 1rem;
  font-weight: normal;
}
.a-label__helper--block {
  display: block;
  margin-top: 0.8333333333em;
}
.a-label--heading {
  display: block;
  margin-bottom: 0.5555555556em;
  font-size: 1.125em;
  font-weight: 500;
  letter-spacing: inherit;
  line-height: 1.25;
  text-transform: inherit;
}
p + .a-label--heading, ul + .a-label--heading, ol + .a-label--heading, dl + .a-label--heading, figure + .a-label--heading, img + .a-label--heading, table + .a-label--heading, blockquote + .a-label--heading, h1 + .a-label--heading, .h1 + .a-label--heading, h2 + .a-label--heading, .h2 + .a-label--heading, h3 + .a-label--heading, .h3 + .a-label--heading, h5 + .a-label--heading, .h5 + .a-label--heading, h6 + .a-label--heading, .h6 + .a-label--heading {
  margin-top: 1.6666666667em;
}
@media only all and (max-width: 37.5em) {
  .a-label--heading {
    margin-bottom: 0.625em;
    font-size: 1em;
    line-height: 1.125;
  }
}
.a-label--heading .a-label__helper--block {
  margin-top: 0.625rem;
}